<template>
  <div class="template-container">
    <div class="action-bar">
      <el-button type="primary" size="medium" @click="handleAddTemplate">{{ $t('domainTemplate.addTemplate') }}</el-button>
      <el-input
        :placeholder="$t('domainTemplate.searchPlaceholder')"
        v-model="searchQuery"
        class="search-input"
        clearable
        @clear="handleSearch"
        @input="handleSearch">
        <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
      </el-input>
    </div>
    
    <el-table
      :data="templateList"
      border
      v-loading="loading"
      style="width: 100%">
      <el-table-column prop="id" :label="$t('domainTemplate.id')" width="80" align="center"></el-table-column>
      <el-table-column prop="name" :label="$t('domainTemplate.name')" min-width="120"></el-table-column>
      <el-table-column prop="email" :label="$t('domainTemplate.contactEmail')" min-width="150"></el-table-column>
      <el-table-column prop="mobile" :label="$t('domainTemplate.contactPhone')" min-width="120"></el-table-column>
      <el-table-column prop="sp" :label="$t('domainTemplate.province')" width="100"></el-table-column>
      <el-table-column prop="country" :label="$t('domainTemplate.country')" width="100"></el-table-column>
      <el-table-column prop="city" :label="$t('domainTemplate.city')" width="100"></el-table-column>
      <el-table-column prop="create_time" :label="$t('domainTemplate.createTime')" width="150" :formatter="formatDate"></el-table-column>
      <el-table-column :label="$t('domainTemplate.operation')" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleEditTemplate(scope.row)">{{ $t('domainTemplate.edit') }}</el-button>
          <el-button type="text" size="small" @click="handleViewTemplate(scope.row)">{{ $t('domainTemplate.view') }}</el-button>
          <el-button type="text" size="small" class="delete-btn" @click="handleDeleteTemplate(scope.row)">{{ $t('domainTemplate.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>
    
    <!-- 表单对话框 -->
    <el-dialog 
      :title="dialogType === 'add' ? $t('domainTemplate.addTitle') : $t('domainTemplate.editTitle')" 
      :visible.sync="dialogVisible" 
      width="600px"
      append-to-body
      :modal-append-to-body="false"
      @close="resetForm">
      <el-form :model="templateForm" :rules="formRules" ref="templateForm" label-width="100px">
        <el-form-item label="模板类型" prop="type">
          <el-radio-group v-model="templateForm.type">
            <el-radio :label="1">个人</el-radio>
            <el-radio :label="2">企业</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('domainTemplate.name')" prop="name">
          <el-input v-model="templateForm.name" :placeholder="$t('domainTemplate.name')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('domainTemplate.contactEmail')" prop="email">
          <el-input v-model="templateForm.email" :placeholder="$t('domainTemplate.contactEmail')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('domainTemplate.contactPhone')" prop="mobile">
          <el-input v-model="templateForm.mobile" :placeholder="$t('domainTemplate.contactPhone')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('domainTemplate.country')" prop="country">
          <el-input v-model="templateForm.country" :placeholder="$t('domainTemplate.country')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('domainTemplate.province')" prop="sp">
          <el-input v-model="templateForm.sp" :placeholder="$t('domainTemplate.province')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('domainTemplate.city')" prop="city">
          <el-input v-model="templateForm.city" :placeholder="$t('domainTemplate.city')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('domainTemplate.address')" prop="address">
          <el-input v-model="templateForm.address" :placeholder="$t('domainTemplate.address')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('domainTemplate.zipCode')" prop="pc">
          <el-input v-model="templateForm.pc" :placeholder="$t('domainTemplate.zipCode')"></el-input>
        </el-form-item>
        
        
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('domainTemplate.cancelForm') }}</el-button>
        <el-button type="primary" @click="submitForm">{{ $t('domainTemplate.submitForm') }}</el-button>
      </span>
    </el-dialog>
    
    <!-- 查看对话框 -->
    <el-dialog 
      :title="$t('domainTemplate.viewTitle')" 
      :visible.sync="viewDialogVisible" 
      width="600px"
      append-to-body
      :modal-append-to-body="false">
      <div class="template-detail" v-if="currentTemplate">
        <div class="detail-item">
          <span class="label">{{ $t('domainTemplate.name') }}：</span>
          <span class="value">{{ currentTemplate.name }}</span>
        </div>
        <div class="detail-item">
          <span class="label">{{ $t('domainTemplate.contactEmail') }}：</span>
          <span class="value">{{ currentTemplate.email }}</span>
        </div>
        <div class="detail-item">
          <span class="label">{{ $t('domainTemplate.contactPhone') }}：</span>
          <span class="value">{{ currentTemplate.mobile }}</span>
        </div>
        <div class="detail-item">
          <span class="label">{{ $t('domainTemplate.country') }}：</span>
          <span class="value">{{ currentTemplate.country || '--' }}</span>
        </div>
        <div class="detail-item">
          <span class="label">{{ $t('domainTemplate.province') }}：</span>
          <span class="value">{{ currentTemplate.sp || '--' }}</span>
        </div>
        <div class="detail-item">
          <span class="label">{{ $t('domainTemplate.city') }}：</span>
          <span class="value">{{ currentTemplate.city || '--' }}</span>
        </div>
        <div class="detail-item">
          <span class="label">{{ $t('domainTemplate.address') }}：</span>
          <span class="value">{{ currentTemplate.address }}</span>
        </div>
        <div class="detail-item">
          <span class="label">{{ $t('domainTemplate.zipCode') }}：</span>
          <span class="value">{{ currentTemplate.pc }}</span>
        </div>
        <div class="detail-item">
          <span class="label">{{ $t('domainTemplate.createTime') }}：</span>
          <span class="value">{{ formatDate(null, currentTemplate) }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
  
</template>

<script>
export default {
  name: 'DomainTemplate',
  data() {
    return {
      // 表格数据
      templateList: [],
      // 加载状态
      loading: false,
      // 搜索关键词
      searchQuery: '',
      // 分页配置
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 表单对话框可见性
      dialogVisible: false,
      // 查看对话框可见性
      viewDialogVisible: false,
      // 对话框类型: add-新增, edit-编辑
      dialogType: 'add',
      // 当前选中的模板
      currentTemplate: null,
      // 图片预览URL
      imageUrl: '',
      // 表单数据
      templateForm: {
        id: null,
        name: '', // 域名所有者（个人名字/企业名）
        contact: '', // 联系人
        email: '', // 邮箱
        mobile: '', // 手机号
        city: '', // 城市
        sp: '', // 省份
        country: '', // 国家
        address: '', // 详细地址
        pc: '', // 邮编
        type: 1 // 1个人2企业，默认为个人
      },
      // 表单校验规则
      formRules: {
        name: [
          { required: true, message: this.$t('domainTemplate.templateNameRequired'), trigger: 'blur' },
          { min: 2, max: 50, message: this.$t('domainTemplate.name') + '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        contactEmail: [
          { required: true, message: this.$t('domainTemplate.contactEmailRequired'), trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: this.$t('domainTemplate.contactPhoneRequired'), trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        sp: [
          { required: true, message: this.$t('domainTemplate.provinceRequired'), trigger: 'blur' }
        ],
        city: [
          { required: true, message: this.$t('domainTemplate.cityRequired'), trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$t('domainTemplate.addressRequired'), trigger: 'blur' }
        ],
        pc: [
          { pattern: /^\d{6}$/, message: '请输入正确的邮政编码', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.fetchTemplateList()
  },
  methods: {
    // 获取模板列表
    fetchTemplateList() {
      this.loading = true
      
      // 构建API请求参数
      const params = {
        page: this.pagination.currentPage,
        limit: this.pagination.pageSize
      }
      
      // 发起API请求获取模板列表
      this.axios.post('/admin/domain/templateList', params, {
        token: true
      }).then(res => {
        const { status, msg, data } = res
        console.log(res);
        
        
        if (status === 200 && data && data.data && data.code == 1) {
          const { list, total } = data.data.list;
          // 转换API返回的数据格式为组件需要的格式
          this.templateList = list.map(item => ({
            id: item.id,
            name: item.name,
            email: item.email,
            mobile: item.mobile,
            address: item.address || '',
            sp: item.sp || '',
            country: item.country || '',
            city: item.city || '',
            pc: item.pc || '',
            create_time: item.create_time
          }))
          
          // 更新分页信息
          this.pagination.total = total || this.templateList.length
        } else {
          this.$message.error(msg || '获取模板列表失败')
          this.templateList = []
        }
        
        this.loading = false
      }).catch(error => {
        console.error('获取模板列表失败:', error)
        this.$message.error('获取模板列表失败，请稍后重试')
        this.loading = false
        this.templateList = []
      })
    },
    
    // 格式化日期
    formatDate(row, column) {
      const date = column ? column.create_time : row.create_time
      if (!date) return '--'
      
      // 处理时间戳格式
      const timestamp = typeof date === 'number' ? date * 1000 : date
      const d = new Date(timestamp)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hour = String(d.getHours()).padStart(2, '0')
      const minute = String(d.getMinutes()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hour}:${minute}`
    },
    
    // 获取证件类型名称
    getIdTypeName(type) {
      const idTypeMap = {
        'idcard': this.$t('domainTemplate.idCard'),
        'passport': this.$t('domainTemplate.passport'),
        'business_license': this.$t('domainTemplate.businessLicense')
      }
      return idTypeMap[type] || type
    },
    
    // 处理搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchTemplateList()
    },
    
    // 处理页码变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchTemplateList()
    },
    
    // 处理每页条数变化
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.fetchTemplateList()
    },
    
    // 处理添加模板
    handleAddTemplate() {
      this.dialogType = 'add'
      this.dialogVisible = true
      this.resetForm()
      
      // 预填充测试数据
      this.templateForm = {
        id: null,
        name: 'FFCLOUD Co., Ltd.', // 域名所有者（个人名字/企业名）
        email: 'ffcloud@ffcloudcdn.com', // 邮箱
        mobile: '8528014901', // 手机号
        city: 'Hong Kong', // 城市
        sp: 'Hong Kong', // 省份
        country: 'HK', // 国家
        address: 'No. 34, Lane 921, On Ning Path, Kowloon, Hong Kong', // 详细地址
        pc: '999077', // 邮编
        type: 2 // 1个人2企业，默认为个人
      }
    },
    
    // 处理编辑模板
    handleEditTemplate(row) {
      this.dialogType = 'edit'
      this.dialogVisible = true
      this.templateForm = { ...row }
    },
    
    // 处理查看模板
    handleViewTemplate(row) {
      this.currentTemplate = { ...row }
      this.viewDialogVisible = true
    },
    
    // 处理删除模板
    handleDeleteTemplate(row) {
      this.$confirm(this.$t('domainTemplate.deleteConfirm'), this.$t('system.prompt'), {
        confirmButtonText: this.$t('system.confirm'),
        cancelButtonText: this.$t('system.cancel'),
        type: 'warning'
      }).then(() => {
        // 删除模板API请求
        this.axios.post('/admin/domain/deleteTemplate', {
          id: row.id
        }, {
          token: true
        }).then(res => {
          const { status, msg } = res
          
          if (status === 200) {
            this.$message({
              type: 'success',
              message: msg || this.$t('domainTemplate.deleteSuccess')
            })
            // 重新获取列表
            this.fetchTemplateList()
          } else {
            this.$message.error(msg || this.$t('domainTemplate.deleteError'))
          }
        }).catch(error => {
          console.error('删除模板失败:', error)
          this.$message.error(this.$t('domainTemplate.deleteError'))
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('domainTemplate.cancelDelete')
        })
      })
    },
    
    // 提交表单
    submitForm() {
      this.$refs.templateForm.validate((valid) => {
        if (valid) {
          if (this.dialogType === 'add') {
            // 新增模板
            const params = {
              name: this.templateForm.name,
              contact: this.templateForm.contact,
              email: this.templateForm.email,
              mobile: this.templateForm.mobile,
              city: this.templateForm.city,
              sp: this.templateForm.sp,
              country: this.templateForm.country,
              address: this.templateForm.address,
              pc: this.templateForm.pc,
              type: this.templateForm.type
            }
            
            this.axios.post('/admin/domain/addTemplate', params, {
              token: true
            }).then(res => {
              console.log("add template", res);
              
              const { status, msg, data } = res
              
              if (status === 200) {
                this.$message({
                  type: 'success',
                  message: msg || this.$t('domainTemplate.addSuccess')
                })
                this.dialogVisible = false
                this.fetchTemplateList()
              } else {
                this.$message.error(msg || this.$t('domainTemplate.addError'))
              }
            }).catch(error => {
              console.error('添加模板失败:', error)
              this.$message.error(this.$t('domainTemplate.addError'))
            })
          } else {
            // 编辑模板 (API文档中没有提供编辑接口，可以添加自定义实现)
            this.$message.info('当前API暂不支持编辑模板功能')
            this.dialogVisible = false
          }
        } else {
          return false
        }
      })
    },
    
    // 重置表单
    resetForm() {
      if (this.$refs.templateForm) {
        this.$refs.templateForm.resetFields()
      }
      // 重置图片预览
      this.imageUrl = ''
      this.templateForm = {
        id: null,
        name: '', // 域名所有者（个人名字/企业名）
        contact: '', // 联系人
        email: '', // 邮箱
        mobile: '', // 手机号
        city: '', // 城市
        sp: '', // 省份
        country: '', // 国家
        address: '', // 详细地址
        pc: '', // 邮编
        type: 1 // 1个人2企业，默认为个人
      }
    },
    
    // 图片上传前处理
    beforeIdImgUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg';
      const isLt2M = file.size / 1024 < 2048 && file.size / 1024 > 5;
      
      if (!isJPG) {
        this.$message.error('图片只能是JPG/JPEG格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小必须在5KB到2MB之间!');
        return false;
      }
      
      // 转换为base64
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.templateForm.id_img = reader.result;
          this.imageUrl = reader.result;
          resolve(false);
        }
      });
    }
  }
}
</script>

<style scoped>
.template-container {
  padding: 20px;
}

.action-bar {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}

.search-input {
  width: 300px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.delete-btn {
  color: #F56C6C;
}

.template-detail {
  padding: 10px;
}

.detail-item {
  margin-bottom: 15px;
  line-height: 22px;
}

.detail-item .label {
  display: inline-block;
  width: 100px;
  color: #606266;
  font-weight: bold;
}

.detail-item .value {
  color: #333;
}
</style>